import styled from "styled-components";

export const AboutSectionContainer = styled.section`
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    background-color: #262e36;
    scroll-snap-align: start;
`